export enum ApiDocLayout {
  TwoColumn = 'TwoColumn',
  OneColumn = 'OneColumn',
}
